import React from "react"
import { LightgalleryItem, LightgalleryProvider, withLightgallery } from "react-lightgallery"

const SeePhotosLink = withLightgallery(({ openGallery }: { openGallery: Function }) => {
    return (
        <a
            className="tr-pointer primary-text"
            onClick={() => {
                openGallery("any")
            }}>
            See parcel files
        </a>
    )
})

const ImagesViewer = ({ parcel }: { parcel: Record<string, any> }) => {
    return (
        <LightgalleryProvider>
            {(parcel?.ParcelFiles ? parcel?.ParcelFiles : parcel?.PurchaseAttachments)?.map(
                (file: Record<string, any>, index: number) => {
                    const imageLink = file.file
                        ? file.file
                        : [
                              file?.Attachment?.domain,
                              file?.Attachment?.folder_path,
                              file?.Attachment?.attachment_name
                          ].join("")
                    return (
                        <div className={"d-none"} key={`${parcel?.uuid}-file-${file?.id}`} data-src={imageLink}>
                            <LightgalleryItem group={"any"} src={imageLink}>
                                <img alt="..." src={imageLink} />
                            </LightgalleryItem>
                        </div>
                    )
                }
            )}
            <SeePhotosLink />
        </LightgalleryProvider>
    )
}

export default ImagesViewer
